<div class="main-component container">
    <div class="content">

        <!-- 1. On souscrit à ranking$ une seule fois pour tout le composant -->
        @if (ranking$ | async; as rankings) {
        @if (rankings.length > 0) {
        <h3 class="ranking-table-title">
            @switch (raceStatus) {
            @case ('noStarted') { Liste des coureurs }
            @case ('inProgress') { Classement }
            @case ('finish') {
            @if(resultsStatus) {
            <div class="d-flex flex-row align-items-center justify-content-center">
                <span>Résultats</span>
                <span class="result-type"
                    [ngClass]="{'prv': resultsStatus === 'prv', 'def': resultsStatus === 'def'}">{{resultStatusLabel(resultsStatus)}}</span>
            </div>
            }
            }
            @default {
            <p class="small text-it">Pas d'information sur le statut de la course</p>
            }
            }
        </h3>

        <div class="input-group mb-3 filter">
            <span class="input-group-text">Rechercher un coureur</span>
            <input type="text" class="form-control" placeholder="Dossard, nom, prénom, club" aria-label="runner-info"
                aria-describedby="runner-info" [(ngModel)]="searchTerm">
        </div>

        @if (isOnRankingMode) {
        <div class="mb-2">
            {{nbRanked}} / {{nbRegistred}} coureurs classés
        </div>
        }

        <table class="tableRanking">
            <tr class="header-row">
                @if (isOnRankingMode) {
                <th class="header-cell cell-center">Class.</th>
                }
                <th class="header-cell cell-center" [ngClass]="{'d-none d-sm-table-cell': isOnRankingMode}">Doss.</th>
                <th class="header-cell">
                    @if (isTeamRace) {Equipe} @else {Coureur}
                </th>
                <th class="header-cell d-none d-sm-table-cell">Club</th>
                <th class="header-cell cell-center d-none d-sm-none d-lg-table-cell">Pays</th>
                <th class="header-cell cell-center cell-center d-none d-sm-table-cell">Catégorie</th>
                @if (isOnRankingMode) {
                <th class="header-cell">Status</th>
                }
                @if (isOnRankingMode && displaySpeed) {
                <th class="header-cell d-none d-sm-none d-lg-table-cell">Vitesse</th>
                }
            </tr>

            <!-- 2. On passe 'rankings' au filtre au lieu de refaire 'ranking$ | async' -->
            @for (r of rankings | filterRank : searchTerm; track $index) {
            <tr class="rowTableRanking" (click)="displayRunnerData(r)">
                @if (isOnRankingMode) {<td class="table-cell cell-center">{{getRank(r)}}</td>}
                <td class="table-cell cell-center" [ngClass]="{'d-none d-sm-table-cell': isOnRankingMode}">
                    @if (isTeamRace) { {{r.team?.chip}} } @else { {{r.runner?.bib}} }
                </td>
                <td class="table-cell cell-bold">
                    @if (isTeamRace) {
                    {{r.team?.name}}
                    } @else {
                    <div>{{r.runner?.firstName | titlecase}} {{r.runner?.lastName | titlecase}}</div>
                    <div class="club-runner d-flex d-sm-none d-lg-none d-md-none">{{r.runner?.club}}</div>
                    }
                </td>
                <td class="table-cell d-none d-sm-table-cell">
                    @if (isTeamRace) { {{r.team?.club}} } @else { {{r.runner?.club}} }
                </td>
                <td class="table-cell cell-center d-none d-sm-none d-lg-table-cell">
                    @if (r.runner && r.runner.country) {
                    <img crossorigin="anonymous" [src]="getCountryFlagUrl(r.runner.country)" [alt]="r.runner.country"
                        class="country-flag" draggable="false">
                    }
                </td>
                <td class="table-cell cell-center d-none d-sm-table-cell">
                    @if (isTeamRace) { {{r.team?.category?.code}} } @else { {{r.runner?.category?.event}}
                    {{r.runner?.sex | uppercase}} }
                </td>
                @if (isOnRankingMode) {
                <td class="table-cell d-none d-sm-none d-lg-table-cell text-center">
                    @if (isTeamRace) {
                    <div class="d-flex flex-column">
                        @if (r.team?.status; as status) { <span
                            class="stick green">{{getRunnerStatusLabel(status)}}</span> }
                        @if (hisFinisher(r) && r.time) {
                        <span class="raceTime">{{formatTime(r.time)}}</span>
                        }
                    </div>
                    } @else {
                    <div class="d-flex flex-column">
                        @if (r.runner?.status; as status) { <span
                            class="stick green">{{getRunnerStatusLabel(status)}}</span> }
                        @if (hisFinisher(r) && r.time) {
                        <span class="raceTime">{{formatTime(r.time * 1000)}}</span>
                        }
                    </div>
                    }
                </td>
                }
                @if (displaySpeed) {
                <td class="table-cell d-none d-sm-none d-lg-table-cell">
                    @if (r.speed && r.speed !== 0 && isOnRankingMode && (r.team?.status === 'fnr' || r.team?.status ===
                    'orc')) {
                    {{r.speed.toFixed(2)}} km/h
                    }
                </td>
                }
            </tr>
            }
        </table>
        } @else {
        <p>Aucun tableau des favoris, classement ou résultats disponibles pour le moment</p>
        }

        } @else {
        <!-- État de chargement initial -->
        <p>Chargement des données en cours...</p>
        }

        @if (isOnRankingMode) {
        <p class="small">Toute réclamation devra être formulée au plus tard 15j après la fin de
            l'évènement à l'adresse suivante: <a
                href="mailto:contact@alpsoutdoorevents.com">contact@alpsoutdoorevents.com</a></p>
        }

    </div>
</div>